import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { timeFormat } from 'd3';
import ArticleListing from '../../reusable/Articles/ArticleListing';
import headerActions from './../../reusable/Header/Header.actions';
import entitiesApi from '../../api/Entities.api';
import api from './News.api';
import commonApi from './../../api/Common.api';
import utils from './../../utils/utilities';
import xhr from './../../utils/xhr';
import reduxStore from './../../reduxStore';


class TrendingTermsListingPage extends Component {

    constructor(props) {
        super(props);

        this.pestle = props.routeParams.pestle;
        this.date = props.routeParams.date;
        this.params = JSON.parse(props.routeParams.params);
        this.languages = utils.extractLanguagesFilter(reduxStore.getState().user.preferences.filters.languageFilter);
        this.state = {
            timestamp: null
        }
    }

    componentDidMount() {
        this.getTimestamp();
        headerActions.updateHeaderContent(' ');
        if (this.params.riskEntityIds && this.params.riskEntityIds.length === 1) {
            entitiesApi.specific([this.params.riskEntityIds[0]]).then((companies) => {
                headerActions.updateHeaderContent(
                    <FormattedMessage id='HeaderFooterNav_SubMenu_UIText_subMenu.newsArticles'
                                      values={{
                                          entityTitle:  companies[0].companyTitle,
                                          trendingTerm: <FormattedMessage id={"General_CoreFunctionality_UIText_general." + this.pestle} />,
                                          daysNumber:   this.dateFormat(this.date)
                                      }}
                    />,
                    'termsresultstips-field?lbu=US&locale=en_US&audience=all'
                );
            })
        } else {
            headerActions.updateHeaderContent(
                <FormattedMessage id='HeaderFooterNav_SubMenu_UIText_subMenu.newsArticles'
                                  values={{
                                      entityTitle:  '',
                                      trendingTerm: <FormattedMessage id={"General_CoreFunctionality_UIText_general." + this.pestle} />,
                                      daysNumber:   this.dateFormat(this.date)
                                  }} />,
                'termsresultstips-field?lbu=US&locale=en_US&audience=all'
            );
        }
    }

    getTimestamp() {
        commonApi.loadListingTimestamp()
            .then((timestamp)=>{
                this.setState({ timestamp });
            }).catch((error) => {
                utils.logError(error, 'CompanyArticlesPage.componentWillMount() - Error fetching timestamp:');
                xhr.handleAllErrors(error);
            });
    }

    dateFormat = timeFormat('%b %d %Y');

    render() {
        return <div className="trending-terms-page">
            { this.state.timestamp && <ArticleListing url={`/api/articles/pestle/${this.pestle}`}
                                                      countUrl={`/api/articles/count/pestle/${this.pestle}`}
                                                      api={api}
                                                      urlParams={{
                                                          ...this.params,
                                                          timestamp: this.state.timestamp,
                                                          languages: this.languages
                                                      }}
                                                      filters={{ pestle: this.pestle }}
                                                      helpUrl={'termsresultstips-field?lbu=US&locale=en_US&audience=all'} />}
        </div>
    }
}

export default TrendingTermsListingPage;


// WEBPACK FOOTER //
// ./src/scripts/pages/News/NewsListingPage.jsx